const SEARCH_AMOUNTS = {
    DROPDOWN: 6,
    WITHOUT_DROPDOWN: 100,
    WITHOUT_DROPDOWN_2: 40
};

export { SEARCH_AMOUNTS };



// WEBPACK FOOTER //
// ./src/app/shared/constants/search-amounts.ts